import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";
import { ClearButton, Delete2Button } from "../buttons/iconButtons/action/MainCollection";
import { CopyButton, EmptySquareButton, HighLightButton } from "../buttons/iconButtons/editor/ActionCollection";
import { AdditionalButton } from "../buttons/iconButtons/other/PanelCollection";
import { KizBarcodeButton } from "../buttons/iconButtons/kiz/KizBarcodeCollection";
import BaseCommandsPanel from "./BaseCommandsPanel";
import Tooltip from "../tooltips/Tooltip";

export interface IPanelEvent {
    disabled?: boolean
    onClick: () => any
    onSubItemClick?: () => any
}
interface IDocumentsPanelProps {
    edit?: IPanelEvent
    delete?: IPanelEvent
    kiz?: IPanelEvent
    clear?: IPanelEvent
    copy?: IPanelEvent
    groupProcessing?: IPanelEvent & { value: boolean }
    // Refs для точечных target-элементов tour.
    tourRef?: RefObject<HTMLDivElement>
    tourRefs?: {
        kiz?: RefObject<HTMLDivElement>
    }
}

interface IButtonGroup {
    iconButton: JSX.Element
}

const PositionEditPanel: FC<IDocumentsPanelProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('documentsCommandsPanel.' + value)

    const groupsArr: IButtonGroup[] = []

    if (props.kiz) {
        groupsArr.push({
            iconButton: (
                // Target для tour: кнопка КИЗ.
                <div ref={props.tourRefs?.kiz} style={{ display: "flex" }}>
                    <Tooltip title={baseT('scanKiz')}>
                        <KizBarcodeButton sizeVariant="mini" {...props.kiz} />
                    </Tooltip>
                </div>
            )
        })
    }

    if (props.edit) {
        groupsArr.push({
            iconButton: (
                <Tooltip title={baseT('editNote')}>
                    <HighLightButton sizeVariant="mini" {...props.edit} />
                </Tooltip>
            )
        })
    }

    if (props.delete) {
        groupsArr.push({
            iconButton: (
                <Tooltip colorVariant={'danger'} title={baseT('deleteNote')}>
                    <Delete2Button sizeVariant="mini" colorVariant="danger" {...props.delete} />
                </Tooltip>
            )
        })
    }

    if (props.clear) {
        groupsArr.push({
            iconButton: (
                <Tooltip colorVariant={'danger'} title={baseT('clearNote')}>
                    <ClearButton sizeVariant="mini" hidden={props.clear === undefined} colorVariant="danger" {...props.clear} />
                </Tooltip>
            )
        });
    }

    if (props.copy) {
        groupsArr.push({
            iconButton: <Tooltip title={baseT('copyNote')}>
                        <CopyButton sizeVariant="mini" {...props.copy}/>
                    </Tooltip>
        })
    }

    return (
        <div ref={props.tourRef} style={{ display: "flex" }}>
            <BaseCommandsPanel groups={
                [groupsArr, ...(props.groupProcessing ? [[{
                    iconButton: <Tooltip title="Групповая обработка">
                        {props.groupProcessing.value
                            ? <AdditionalButton sizeVariant="mini" {...props.groupProcessing} />
                            : <EmptySquareButton sizeVariant="mini" {...props.groupProcessing} />}
                    </Tooltip>
                }]] : [])]
            }></BaseCommandsPanel>
        </div>
    )
}
export default PositionEditPanel
